import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getCSRForms(
  policyId,
  portal = "customer",
  company,
  issueState,
  residentState,
  productType,
  contractType
) {
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
      Authorization: `bearer ${getToken()}`,
    },
  };

  const queryParams = new URLSearchParams({
    Portal: portal,
    isCsr: "true",
    PolicyId: policyId || "",
    Company: company || "",
    IssueState: issueState || "",
    ResidentState: residentState || "",
    ProductType: productType || "",
    ContractType: contractType || "",
  });

  const url = `${config.REG_API_BASE_URL}/Forms?${queryParams.toString()}`;

  const response = await fetch(url, options);

  if (!response.ok) {
    throw response;
  }

  return response.json();
}
